<template>
    <tr>
        <td class="editor-content editor-label">{{selectedComponent.type}}</td>
        <td class="editor-content">
            <input class="form-control editor-form" type="text" v-model="selectedComponent.value"/>
        </td>
    </tr>
</template>

<script>
    export default {
        name: 'LabelEditor',
        props: ['selectedComponent'],
        data () {
            return {
                model: webase.model
            }
        }
    }
</script>
